import { useEffect, useRef } from 'react';

import { STEPS } from './steps.constants';
import type { StepKey } from './steps.types';
import { StepperWrapper, StepItem } from './styled';

export type VersionType = 'cve-lite' | 'cve-pro';

type Props = {
  current: StepKey;
  version: VersionType; // nova prop
  theme: string;
};

export default function Stepper({ current, version }: Props) {
  const wrapRef = useRef<HTMLDivElement>(null);

  // controla quais steps existem por versão
  const visibleSteps: readonly StepKey[] =
    version === 'cve-pro' ? STEPS : (['user'] as const);

  // garante que sempre tenha um índice válido
  let currentIdx = visibleSteps.indexOf(current);
  if (currentIdx === -1) {
    currentIdx = 0;
  }

  const label = (s: StepKey) =>
    s === 'user'
      ? 'Dados do usuário'
      : s === 'endereco'
      ? 'Endereço'
      : s === 'empresa'
      ? 'Dados da empresa'
      : 'Conta bancária';

  // Auto-centraliza o step ativo no mobile
  useEffect(() => {
    const wrap = wrapRef.current;
    if (!wrap) return;
    const items = wrap.querySelectorAll<HTMLElement>('[data-step]');
    const el = items[currentIdx];
    if (!el) return;
    el.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest',
    });
  }, [currentIdx]);

  return (
    <StepperWrapper ref={wrapRef}>
      {visibleSteps.map((s, i) => (
        <StepItem
          key={s}
          data-step
          active={i === currentIdx}
          aria-current={i === currentIdx ? 'step' : undefined}
        >
          <div className='circle'>{i + 1}</div>
          <span className='label'>{label(s)}</span>
        </StepItem>
      ))}
    </StepperWrapper>
  );
}
